<script>
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Location from "@/components/modals/property-location.vue";
import Employee from "@/components/modals/employee-hris.vue";
import FundCluster from "@/components/modals/fund-cluster-list.vue";
import Supplier from "@/components/modals/supplier.vue";
import ItemCategory from "@/components/modals/item-category.vue";
import Unit from "@/components/modals/unit.vue";
export default {
    name: "PropertyModal",
    components: {
        DatePicker,
        MaskedInput,
        Location,
        FundCluster,
        Supplier,
        ItemCategory,
        Unit,
        Employee,
    },
    props: {
        modalTitle: {
            type: String,
            required: true,
        },
    },
    validations: {
        form: {
            name: { required },
            poNumber: { required },
            dateAcquired: { required },
            amount: { required },
            lifespanInYears: { required },
            yearlyDepreciation: { required },
            salvageValue: { required },
            itemCategoryId: { required },
            supplier: { required },
            condition: { required },
            unit: { required }
        }
    },
    data() {
        return {
            generatePropertyNumber: true,
            generateAssignmentNumber: true,
            submitted: false,
            form: {
                id: null,
                name: "",
                brand: "",
                model: "",
                specification: "",
                color: "",
                dimensionDescription: "",
                materialUsed: "",
                packageDescription: "",
                propertyNumber: "",
                serialNumber: "",
                dateAcquired: "",
                warrantyStartDate: "",
                warrantyEndDate: "",
                amount: "",
                lifespanInYears: "",
                yearlyDepreciation: "",
                salvageValue: "",
                itemCategoryId: "",
                supplierId: 0,
                supplier: "",
                poNumber: "",
                note: "",
                condition: "",
                fundCluster: "",
                fundClusterId: "",
                unit: "",
                propertyId: 0,
                employeeIdNumber: "",
                employeeName: "",
                location: "",
                propertyLocationId: 0,
                assignNotes: "",
                assignmentType: "",
                assignmentNumber: "",
                dateAssigned: "",
                loading: false,
                quantities: [],
            },
            fundCluster: "",
            itemCategory: "",
            quantityMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false
            }),
            percentMask: createNumberMask({
                prefix: "",
                suffix: "%",
                allowDecimal: true,
                integerLimit: 2,
                includeThousandsSeparator: false
            }),
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true
            }),
            secondChildHeight: "1340px",
        };
    },
    methods: {
        onCreate(){
            this.submitted = true;
            this.$v.form.$touch();
            if (this.checkCreateForm() || this.$v.$invalid) return;
            let data = JSON.parse(JSON.stringify(this.form));
            var props = [];
            data.quantities.forEach((x) => {
                var propertyAssignments = [];
                if (data.employeeIdNumber !== null && data.employeeIdNumber !== "") {
                    propertyAssignments.push({
                        propertyId: data.propertyId,
                        employeeIdNumber: data.employeeIdNumber,
                        propertyLocationId: data.propertyLocationId,
                        assignNotes: data.assignNotes,
                        assignmentType: data.assignmentType,
                        assignmentNumber: this.generateAssignmentNumber  ? "" : data.assignmentNumber,
                        dateAssigned: this.getDate(data.dateAssigned)
                    });
                }
                props.push({
                    requisitionItemId: data.requisitionItemId,
                    iarItemId: data.iarItemId,
                    propertyNumber: this.generatePropertyNumber ? "" : x.propertyNumber,
                    serialNumber: x.serialNumber,
                    propertyAssignments: propertyAssignments,
                    name: data.name,
                    brand: data.brand,
                    unit: data.unit,
                    model: data.model,
                    specification: data.specification,
                    color: data.color,
                    dimensionDescription: data.dimensionDescription,
                    materialUsed: data.materialUsed,
                    packageDescription: data.packageDescription,
                    condition: data.condition,
                    dateAcquired: this.getDate(data.dateAcquired),
                    warrantyStartDate: data.warrantyStartDate != "" && data.warrantyStartDate != null  ? this.getDate(data.warrantyStartDate) : "0001-01-01T00:00:00",
                    warrantyEndDate: data.warrantyEndDate != "" && data.warrantyEndDate != null && data.warrantyStartDate != "" && data.warrantyStartDate != null
                        ? this.getDate(data.warrantyEndDate)
                        : "0001-01-01T00:00:00",
                    amount: this.getExactAmt(data.amount),
                    lifespanInYears: data.lifespanInYears,
                    yearlyDepreciation: this.getExactAmt(data.yearlyDepreciation),
                    salvageValue: this.setPercent(data.salvageValue),
                    itemCategoryId: data.itemCategoryId,
                    supplierId: data.supplierId,
                    supplier: data.supplier,
                    poNumber: data.poNumber.trim(),
                    fundCluster: data.fundCluster,
                    fundClusterId: data.fundClusterId,
                    note: data.note
                });
            });
            this.$emit("submit", {
                data: props,
                campusId: this.$store.state.data.selectedCampus.id,
                iarItemId: data.iarItemId,
                requisitionItemId: data.requisitionItemId
            });
        },
        checkCreateForm() {
            if ((this.form.employeeIdNumber != null &&
                this.form.employeeIdNumber != "" &&
                (this.form.propertyLocationId === "" ||
                    this.form.propertyLocationId === null ||
                    this.form.propertyLocationId === 0 ||
                    this.form.assignmentType === "" ||
                    this.form.assignmentType === null ||
                    this.form.dateAssigned === "" ||
                    this.form.dateAssigned === null)) ||
                (this.form.warrantyStartDate != "" &&
                this.form.warrantyStartDate != null &&
                (this.form.warrantyEndDate == "" ||
                    this.form.warrantyEndDate == null)) ||
                (this.form.warrantyEndDate != "" &&
                this.form.warrantyEndDate != null &&
                (this.form.warrantyStartDate == "" ||
                    this.form.warrantyStartDate == null))
            ) {
                return true;
            } else return false;
        },
        fillSerialNumber(index) {
            if (isNaN(parseFloat(this.form.quantities[index].serialNumber.slice(-3)))) {
                this.showToast("Invalid Serial Number", "warning");
            } else {
                for (let x = index + 1; x < this.form.quantities.length; x++) {
                    let stringLength = this.form.quantities[x - 1].serialNumber.length;
                    let string = this.form.quantities[x - 1].serialNumber;
                    this.form.quantities[x].serialNumber = string.slice(0, stringLength - 3).concat((parseFloat(string.slice(-3)) + 1).toString().padStart(3, "0"));
                }
            }
        },
        getItemCategory() {
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.form.itemCategoryId = data.id;
            this.itemCategory = data.name;
        },
        getSupplier() {
            this.$bvModal.show("supplier-modal");
        },
        dropSupplier(data) {
            this.form.supplierId = data.id;
            this.form.supplier = data.name;
        },
        removeSupplier() {
            this.form.supplierId = 0;
            this.form.supplier = "";
        },
        getUnit() {
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.form.unit = data.unitName;
        },
        getFundCluster() {
            this.$refs.fundcluster.getData();
            this.$bvModal.show("fund-cluster-modal");
        },
        dropFundCluster(data) {
            this.form.fundClusterId = data.id;
            this.fundCluster = data.cluster;
        },
        getLocation() {
            this.$refs.location.getData(this.$store.state.data.selectedCampus.id);
            this.$bvModal.show("location-modal");
        },
        dropLocation(data) {
            this.form.propertyLocationId = data.location.id;
            this.form.location = data.location.location;
        },
        removeLocation() {
            this.form.propertyLocationId = 0;
            this.form.location = "";
        },
        getEmployee() {
            this.$refs.employee.resetData();
            this.$bvModal.show("externalEmployee-modal");
        },
        dropEmployee(data){
            this.form.employeeIdNumber = data.idNo;
            this.form.employeeName = `${data.firstName} ${data.middleName ? `${data.middleName[0]}.` : ""} ${data.lastName}`;
        },
        removeEmployee() {
            this.form.employeeIdNumber = "";
            this.form.employeeName = "";
        },
        disabledRange(date) {
            return date < new Date(this.form.warrantyStartDate);
        },
        calculateYearlyDepreciation() {
            if (
                this.form.amount == null ||
                this.form.amount == "" ||
                this.form.lifespanInYears == null ||
                this.form.lifespanInYears == "" ||
                this.form.salvageValue == null ||
                this.form.salvageValue == ""
            ) {
                this.form.yearlyDepreciation = null;
            } else if (
                this.form.amount == 0 ||
                this.form.lifespanInYears == 0 ||
                this.form.dateAcquired == null ||
                this.form.dateAcquired == ""
            ) {
                this.form.yearlyDepreciation = "0";
            } else {
                var value =
                (parseFloat(this.getExactAmt(this.form.amount)) -
                    (parseFloat(this.setPercent(this.form.salvageValue)) / 100) *
                    parseFloat(this.getExactAmt(this.form.amount))) /
                parseFloat(this.getExactAmt(this.form.lifespanInYears));
                this.form.yearlyDepreciation = value ? value.toFixed(2).toString() : null;
            }
        },
        onReset(data, requisition){
            this.generatePropertyNumber = true;
            this.generateAssignmentNumber = true;
            this.$v.$reset();
            this.submitted = false;
            this.form = {
                id: null,
                name: data.itemName || "",
                specification: data.description || "",
                color: "",
                dimensionDescription: "",
                materialUsed: "",
                packageDescription: "",
                propertyNumber: "",
                serialNumber: "",
                dateAcquired: new Date(),
                warrantyStartDate: !data.warrantyStartDate.includes("0001-01-01")
                    ? new Date(data.warrantyStartDate)
                    : "",
                warrantyEndDate: !data.warrantyEndDate.includes("0001-01-01")
                    ? new Date(data.warrantyEndDate)
                    : "",
                amount: data.unitCost ? data.unitCost.toString() : "",
                lifespanInYears: "",
                yearlyDepreciation: "",
                salvageValue: "5",
                itemCategoryId: data.itemCategoryId || "",
                itemCategory: data.itemCategory || "",
                supplierId: requisition.supplierId || 0,
                supplier: requisition.supplier || "",
                poNumber: requisition.poNumber || "",
                note: "",
                condition: "New",
                fundCluster: data.fundSource || "",
                fundClusterId: data.fundClusterId || "",
                unit: data.unit || "",
                propertyId: 0,
                employeeIdNumber: data.endUserId || "",
                employeeName: data.endUser || "",
                location: data.propertyLocation
                    ? data.propertyLocation.location
                    : "",
                propertyLocationId: data.propertyLocationId
                    ? data.propertyLocationId
                    : 0,
                assignNotes: data.note || "",
                assignmentType: "",
                assignmentNumber: "",
                dateAssigned: new Date(requisition.requisitionDate) || "",
                requisitionItemId: data.id,
                iarItemId: data.iarItemId,
                quantities: [],
            };
            this.itemCategory = data.itemCategory || "";
            this.fundCluster = data.fundCluster || "";
            for (var x = 0; x < data.quantity; x++) {
                this.form.quantities.push({
                    index: x,
                    serialNumber: "",
                    propertyNumber: ""
                });
            }
        },
        async setHeight(){
            await this.wait(500);
            if (this.$refs.rightPanel) {
                this.secondChildHeight = this.$refs.rightPanel.clientHeight + "px";
            }
        },
        setPercent(percent) {
            if (percent.includes("%")) {
                return percent.substring(0, percent.length - 1);
            } else return percent;
        },
    },
};
</script>
<template>
    <b-modal
      id="modal-property"
      :title="modalTitle"
      size="xl"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
        <form
            @submit.prevent="onCreate"
            class="needs-validation mt-3"
            ref="fcForm"
        >
            <div class="d-flex flex-row">
                <div class="me-2" :style="{height: secondChildHeight, width: '300px', }">
                    <div class="border border-2 p-3 h-100">
                        <label class="font-size-15 mb-0">
                            {{ form.quantities ? `${form.quantities.length} ${form.quantities.length > 1 ? "Items" : "Item"}` : "No Items"}}
                        </label>
                        <div
                            class="form-check form-checkbox-outline form-check-success mb-3"
                        >
                            <input
                                type="checkbox"
                                id="autoGeneratePropertyNumber"
                                checked="checked"
                                class="form-check-input"
                                v-model="generatePropertyNumber"
                            />
                            <label
                                for="autoGeneratePropertyNumber"
                                class="font-size-12 form-check-label"
                            >
                                Auto Generate Property Number
                            </label>
                        </div>
                        <hr />
                        <div style="height: calc(100% - 100px);overflow-y:auto;" class="mini-scrollbar pe-3">
                            <div v-for="(x, index) in form.quantities" :key="index">
                                <div :class="{ 'mt-3': index != 0 }">
                                    <b>Item {{ index + 1 }}</b>
                                    <div>
                                        <label class="mb-1">Serial Number </label>
                                        <b-input-group>
                                            <template #append>
                                            <b-button
                                                v-if="x.serialNumber.length > 4"
                                                @click="fillSerialNumber(index)"
                                                variant="outline-info"
                                                title="Auto Fill Serial Numbers Below"
                                                ><i class="mdi mdi-square-edit-outline"></i
                                            ></b-button>
                                            </template>
                                            <input
                                                id="serialNumber"
                                                type="text"
                                                v-model="x.serialNumber"
                                                :placeholder="`Enter Serial Number...`"
                                                class="form-control"
                                                autocomplete="off"
                                                @input="$forceUpdate()"
                                            />
                                        </b-input-group>
                                    </div>
                                    <b-collapse :visible="!generatePropertyNumber">
                                        <div v-if="!generatePropertyNumber" class="mt-2">
                                            <label class="mb-1">Property Number </label>
                                            <input
                                                type="text"
                                                v-model="x.propertyNumber"
                                                placeholder="Enter Property Number..."
                                                class="form-control"
                                                autocomplete="off"
                                            />
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                        </div>
                    <hr />
                    </div>
                </div>
                <div ref="rightPanel" id="rightPanel">
                    <div class="border border-2 p-3 mb-3">
                        <label class="font-size-15 mb-3">Accountable Officer</label>
                        <div class="mb-3">
                            <div
                            class="form-check form-checkbox-outline form-check-success"
                            >
                            <input
                                type="checkbox"
                                id="autoGenerateAssignmentNumber"
                                checked="checked"
                                class="form-check-input"
                                v-model="generateAssignmentNumber"
                            /><label
                                for="autoGenerateAssignmentNumber"
                                class="form-check-label"
                            >
                                Auto Generate PAR/ICS Number
                            </label>
                            </div>
                        </div>
                        <b-collapse :visible="!generateAssignmentNumber">
                            <div v-if="!generateAssignmentNumber" class="mb-3">
                            <label for="assignmentNumber">PAR/ICS Number </label>
                            <input
                                id="assignmentNumber"
                                type="text"
                                v-model="form.assignmentNumber"
                                placeholder="Enter PAR/ICS Number..."
                                class="form-control"
                                autocomplete="off"
                            />
                            </div>
                        </b-collapse>
                        <div class="row">
                            <div class="col-md-6">
                            <div class="mb-3">
                                <label for="employee">Employee</label>
                                <b-input-group>
                                <template #append>
                                    <b-button
                                        v-if="!form.employeeIdNumber"
                                        @click="getEmployee()"
                                        variant="outline-info"
                                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                                    ></b-button>
                                    <b-button
                                        v-else
                                        @click="removeEmployee()"
                                        variant="outline-danger"
                                        title="Remove Employee"
                                    ><i class="mdi mdi-close-thick"></i
                                    ></b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Employee..."
                                    class="form-control"
                                    v-model="form.employeeName"
                                />
                                </b-input-group>
                            </div>
                            <div class="mb-3">
                                <label for="employee">Location</label>
                                <b-input-group>
                                <template #append>
                                    <b-button
                                    v-if="!form.propertyLocationId"
                                    @click="getLocation()"
                                    variant="outline-info"
                                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                                    ></b-button>
                                    <b-button
                                    v-else
                                    @click="removeLocation()"
                                    variant="outline-danger"
                                    title="Remove Supplier"
                                    ><i class="mdi mdi-close-thick"></i
                                    ></b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Location..."
                                    class="form-control"
                                    :class="{
                                    'is-invalid':
                                        submitted &&
                                        form.employeeIdNumber != null &&
                                        form.employeeIdNumber != '' &&
                                        (form.propertyLocationId == '' ||
                                        form.propertyLocationId == null)
                                    }"
                                    v-model="form.location"
                                />
                                </b-input-group>
                                <div
                                v-if="
                                    submitted &&
                                    form.employeeIdNumber != null &&
                                    form.employeeIdNumber != '' &&
                                    (form.propertyLocationId == '' ||
                                        form.propertyLocationId == null)
                                "
                                class="invalid-feedback"
                                >
                                <span>This value is required.</span>
                                </div>
                            </div>
                            </div>
                            <div class="col-md-6">
                            <div class="mb-3">
                                <label for="dateAssigned">Date Assigned</label>
                                <date-picker
                                v-model="form.dateAssigned"
                                :first-day-of-week="1"
                                lang="en"
                                placeholder="Enter Date Assigned..."
                                @input="$forceUpdate()"
                                :class="{
                                    'is-invalid':
                                    submitted &&
                                    form.employeeIdNumber != null &&
                                    form.employeeIdNumber != '' &&
                                    (form.dateAssigned == '' || form.dateAssigned == null)
                                }"
                                ></date-picker>
                                <div
                                v-if="
                                    submitted &&
                                    form.employeeIdNumber != null &&
                                    form.employeeIdNumber != '' &&
                                    (form.dateAssigned == '' || form.dateAssigned == null)
                                "
                                class="invalid-feedback"
                                >
                                <span>This value is required.</span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="assignmentType">Assignment Type </label>
                                <b-form-select
                                class="form-select"
                                :class="{
                                    'is-invalid':
                                    submitted &&
                                    form.employeeIdNumber != null &&
                                    form.employeeIdNumber != '' &&
                                    (form.assignmentType == '' ||
                                        form.assignmentType == null)
                                }"
                                v-model="form.assignmentType"
                                >
                                <b-form-select-option value=""
                                    >Select Type...</b-form-select-option
                                >
                                <b-form-select-option value="New"
                                    >New</b-form-select-option
                                >
                                <b-form-select-option value="Donation"
                                    >Donation</b-form-select-option
                                >
                                <b-form-select-option value="Reassignment"
                                    >Reassignment</b-form-select-option
                                >
                                <b-form-select-option value="Relocate"
                                    >Relocate</b-form-select-option
                                >
                                <b-form-select-option value="Others"
                                    >Others</b-form-select-option
                                >
                                </b-form-select>
                                <div
                                v-if="
                                    submitted &&
                                    form.employeeIdNumber != null &&
                                    form.employeeIdNumber != '' &&
                                    (form.assignmentType == '' ||
                                        form.assignmentType == null)
                                "
                                class="invalid-feedback"
                                >
                                <span>This value is required.</span>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="assignNotes">Notes </label>
                            <textarea
                            id="assignNotes"
                            rows="3"
                            v-model="form.assignNotes"
                            placeholder="Enter Notes..."
                            class="form-control"
                            autocomplete="off"
                            ></textarea>
                        </div>
                    </div>
                    <div class="border border-2 p-3">
                        <label class="font-size-15 mb-3">General Details</label>
                        <div class="row">
                            <div class="col-md-5">
                            <div class="mb-3">
                                <label for="poNumber">P.O. Number </label>
                                <input
                                id="poNumber"
                                type="text"
                                v-model="form.poNumber"
                                placeholder="Enter PO Number..."
                                class="form-control"
                                :class="{
                                    'is-invalid': submitted && $v.form.poNumber.$error
                                }"
                                autocomplete="off"
                                />
                                <div
                                v-if="submitted && $v.form.poNumber.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.poNumber.required"
                                    >This value is required.</span
                                >
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="propertyName">Property Name </label>
                                <input
                                id="propertyName"
                                type="text"
                                v-model="form.name"
                                placeholder="Enter Property Name..."
                                class="form-control"
                                :class="{
                                    'is-invalid': submitted && $v.form.name.$error
                                }"
                                autocomplete="off"
                                />
                                <div
                                v-if="submitted && $v.form.name.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.name.required"
                                    >This value is required.</span
                                >
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="supplier">Supplier </label>
                                <b-input-group>
                                <template #append>
                                    <b-button
                                    @click="getSupplier"
                                    variant="outline-info"
                                    title="Search Supplier"
                                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                                    ></b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    placeholder="Search/Enter Supplier..."
                                    class="form-control"
                                    :class="{
                                    'is-invalid': submitted && $v.form.supplier.$error
                                    }"
                                    v-model="form.supplier"
                                />
                                </b-input-group>
                                <div
                                v-if="submitted && $v.form.supplier.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.supplier.required"
                                    >This value is required.</span
                                >
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="itemCategoryId">Item Category </label>
                                <b-input-group>
                                <template #append>
                                    <b-button
                                    @click="getItemCategory"
                                    variant="outline-info"
                                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                                    ></b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Item Category..."
                                    class="form-control"
                                    :class="{
                                    'is-invalid':
                                        submitted && $v.form.itemCategoryId.$error
                                    }"
                                    v-model="itemCategory"
                                />
                                </b-input-group>
                                <div
                                v-if="submitted && $v.form.itemCategoryId.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.itemCategoryId.required"
                                    >This value is required.</span
                                >
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="unit">Unit </label>
                                <b-input-group>
                                <template #append>
                                    <b-button @click="getUnit()" variant="outline-info"
                                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                                    ></b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Unit..."
                                    class="form-control"
                                    :class="{
                                    'is-invalid': submitted && $v.form.unit.$error
                                    }"
                                    v-model="form.unit"
                                />
                                </b-input-group>
                                <div
                                v-if="submitted && $v.form.unit.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.unit.required"
                                    >This value is required.</span
                                >
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="brand">Brand </label>
                                <input
                                id="brand"
                                type="text"
                                v-model="form.brand"
                                placeholder="Enter Brand..."
                                class="form-control"
                                autocomplete="off"
                                />
                            </div>
                            <div class="mb-3">
                                <label for="condition">Property Condition </label>
                                <b-form-select
                                class="form-select"
                                :class="{
                                    'is-invalid': submitted && $v.form.condition.$error
                                }"
                                v-model="form.condition"
                                >
                                <b-form-select-option value="" disabled
                                    >Select Condition...</b-form-select-option
                                >
                                <b-form-select-option value="New"
                                    >New</b-form-select-option
                                >
                                <b-form-select-option value="Purchased"
                                    >Purchased</b-form-select-option
                                >
                                <b-form-select-option value="Used"
                                    >Used</b-form-select-option
                                >
                                <b-form-select-option value="Donated"
                                    >Donated</b-form-select-option
                                >
                                <b-form-select-option value="Refurbished"
                                    >Refurbished</b-form-select-option
                                >
                                <b-form-select-option value="Re-condition"
                                    >Re-condition</b-form-select-option
                                >
                                </b-form-select>
                                <div
                                v-if="submitted && $v.form.condition.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.condition.required"
                                    >This value is required.</span
                                >
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="specification">Property Specification </label>
                                <textarea
                                id="specification"
                                rows="4"
                                v-model="form.specification"
                                placeholder="Enter Property Specification..."
                                class="form-control"
                                autocomplete="off"
                                ></textarea>
                            </div>
                            <div class="mb-3">
                                <label for="color">Color </label>
                                <input
                                id="color"
                                type="text"
                                v-model="form.color"
                                placeholder="Enter Property Color..."
                                class="form-control"
                                autocomplete="off"
                                />
                            </div>
                            <div class="mb-3">
                                <label for="dimensionDescription"
                                >Dimension Description
                                </label>
                                <input
                                id="dimensionDescription"
                                type="text"
                                v-model="form.dimensionDescription"
                                placeholder="Enter Dimension Description..."
                                class="form-control"
                                autocomplete="off"
                                />
                            </div>
                            </div>
                            <div class="col-md-7">
                            <div class="mb-3">
                                <label for="fundClusterId">Fund Cluster </label>
                                <b-input-group>
                                <template #append>
                                    <b-button
                                    @click="getFundCluster()"
                                    variant="outline-info"
                                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                                    ></b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Fund Cluster..."
                                    class="form-control"
                                    v-model="fundCluster"
                                />
                                </b-input-group>
                            </div>
                            <div class="mb-3">
                                <label for="fundSource">Fund Source </label>
                                <input
                                id="fundSource"
                                type="text"
                                v-model="form.fundCluster"
                                placeholder="Enter Fund Source..."
                                class="form-control"
                                autocomplete="off"
                                />
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-6">
                                <label for="dateAcquired">Date Acquired </label>
                                <date-picker
                                    v-model="form.dateAcquired"
                                    :first-day-of-week="1"
                                    lang="en"
                                    placeholder="Enter Date Acquired..."
                                    @change="calculateYearlyDepreciation()"
                                    :class="{
                                    'is-invalid': submitted && $v.form.dateAcquired.$error
                                    }"
                                ></date-picker>
                                <div
                                    v-if="submitted && $v.form.dateAcquired.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.form.dateAcquired.required"
                                    >This value is required.</span
                                    >
                                </div>
                                </div>
                                <div class="col-md-6">
                                <label for="amount">Amount </label>
                                <masked-input
                                    id="amount"
                                    type="text"
                                    v-model="form.amount"
                                    placeholder="Enter Amount..."
                                    class="form-control"
                                    :class="{
                                    'is-invalid': submitted && $v.form.amount.$error
                                    }"
                                    autocomplete="off"
                                    :mask="currencyMask"
                                    @input="calculateYearlyDepreciation()"
                                ></masked-input>
                                <div
                                    v-if="submitted && $v.form.amount.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.form.amount.required"
                                    >This value is required.</span
                                    >
                                </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4">
                                <label for="salvageValue">Scrap Value </label>
                                <masked-input
                                    id="salvageValue"
                                    type="text"
                                    v-model="form.salvageValue"
                                    placeholder="Enter Scrap Value..."
                                    class="form-control"
                                    :class="{
                                    'is-invalid': submitted && $v.form.salvageValue.$error
                                    }"
                                    autocomplete="off"
                                    :mask="percentMask"
                                    @input="calculateYearlyDepreciation()"
                                ></masked-input>
                                <div
                                    v-if="submitted && $v.form.salvageValue.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.form.salvageValue.required"
                                    >This value is required.</span
                                    >
                                </div>
                                </div>
                                <div class="col-md-4">
                                <label for="lifespanInYears">Life Span in Years </label>
                                <masked-input
                                    id="lifespanInYears"
                                    type="text"
                                    v-model="form.lifespanInYears"
                                    placeholder="Enter Life Span..."
                                    class="form-control"
                                    :class="{
                                    'is-invalid':
                                        submitted && $v.form.lifespanInYears.$error
                                    }"
                                    autocomplete="off"
                                    :mask="quantityMask"
                                    @input="calculateYearlyDepreciation()"
                                ></masked-input>
                                <div
                                    v-if="submitted && $v.form.lifespanInYears.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.form.lifespanInYears.required"
                                    >This value is required.</span
                                    >
                                </div>
                                </div>
                                <div class="col-md-4">
                                <label for="yearlyDepreciation"
                                    >Yearly Depreciation
                                </label>
                                <masked-input
                                    id="yearlyDepreciation"
                                    type="text"
                                    v-model="form.yearlyDepreciation"
                                    placeholder="Calculating..."
                                    class="form-control"
                                    :class="{
                                    'is-invalid':
                                        submitted && $v.form.yearlyDepreciation.$error
                                    }"
                                    autocomplete="off"
                                    disabled
                                    :mask="currencyMask"
                                ></masked-input>
                                <div
                                    v-if="submitted && $v.form.yearlyDepreciation.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.form.yearlyDepreciation.required"
                                    >This value is required.</span
                                    >
                                </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="dateExpected">Warranty Date </label>
                                <div class="row">
                                <div class="col-6">
                                    <date-picker
                                    v-model="form.warrantyStartDate"
                                    :first-day-of-week="1"
                                    lang="en"
                                    @Change="$forceUpdate()"
                                    placeholder="Enter Warranty Start..."
                                    :class="{
                                        'is-invalid':
                                        submitted &&
                                        ((form.warrantyStartDate != '' &&
                                            form.warrantyStartDate != null &&
                                            (form.warrantyEndDate === '' ||
                                            form.warrantyEndDate === null)) ||
                                            (form.warrantyEndDate != '' &&
                                            form.warrantyEndDate != null &&
                                            (form.warrantyStartDate === '' ||
                                                form.warrantyStartDate === null)))
                                    }"
                                    ></date-picker>
                                </div>
                                <div class="col-6">
                                    <date-picker
                                    v-model="form.warrantyEndDate"
                                    :first-day-of-week="1"
                                    lang="en"
                                    @Change="$forceUpdate()"
                                    :disabled-date="disabledRange"
                                    placeholder="Enter Warranty End..."
                                    :class="{
                                        'is-invalid':
                                        submitted &&
                                        ((form.warrantyStartDate != '' &&
                                            form.warrantyStartDate != null &&
                                            (form.warrantyEndDate === '' ||
                                            form.warrantyEndDate === null)) ||
                                            (form.warrantyEndDate != '' &&
                                            form.warrantyEndDate != null &&
                                            (form.warrantyStartDate === '' ||
                                                form.warrantyStartDate === null)))
                                    }"
                                    ></date-picker>
                                </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="model">Model </label>
                                <input
                                id="model"
                                type="text"
                                v-model="form.model"
                                placeholder="Enter Model..."
                                class="form-control"
                                autocomplete="off"
                                />
                            </div>
                            <div class="mb-3">
                                <label for="materialUsed">Material Used </label>
                                <textarea
                                id="materialUsed"
                                rows="2"
                                v-model="form.materialUsed"
                                placeholder="Enter Material Used..."
                                class="form-control"
                                autocomplete="off"
                                ></textarea>
                            </div>
                            <div class="mb-3">
                                <label for="packageDescription">Package Description </label>
                                <textarea
                                id="packageDescription"
                                rows="2"
                                v-model="form.packageDescription"
                                placeholder="Enter Package Description..."
                                class="form-control"
                                autocomplete="off"
                                ></textarea>
                            </div>
                            <div class="mb-3">
                                <label for="note">Notes </label>
                                <textarea
                                id="note"
                                rows="6"
                                v-model="form.note"
                                placeholder="Enter Notes..."
                                class="form-control"
                                autocomplete="off"
                                ></textarea>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">Submit Items</button>
            </div>
        </form>
        <Location ref="location" @dropData="dropLocation($event)"></Location>
        <FundCluster ref="fundcluster" @dropData="dropFundCluster($event)"></FundCluster>
        <Supplier ref="supplier" @dropData="dropSupplier($event)"></Supplier>
        <ItemCategory @dropData="dropItemCat($event)"></ItemCategory>
        <Unit ref="unit" @dropData="dropUnit($event)"></Unit>
        <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    </b-modal>
</template>